<template>
  <div class="whatsapp-optin">
    <riseup-header/>
    <div class="optin-content">
      <div>
        <div class="intro">
          <div>הבוט של riseup מלווה אותך לאורך ההרשמה עם הודעות ב- <img class="whatsapp-icon" :src="require('@/assets/whatsapp.svg')"/></div>
          <div class="lower-intro">בכל שלב ניתן לחזור להרשמה בלחיצה על הלינק שבהודעה.</div>
        </div>
        <img class="optin-img" :src="require('@/assets/whatsapp-optin.jpg')">
      </div>
      <div class="button-wrapper">
        <riseup-button :variant="'primary'" :title="'הבנתי, תודה'" :action="confirm"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../../../Segment';
import RiseupHeader from '../../../../../../base-components/app-header/RiseupHeader.vue';

export default {
  components: {
    RiseupButton: BaseUI.RiseupButton,
    RiseupHeader,
  },
  name: 'WhatsappOptIn',
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('WhatsappOptInEntered');
  },
  methods: {
    ...mapActions('signup', ['sendBotiIntro']),
    confirm() {
      Segment.trackUserInteraction('WhatsappOptInConfirmClicked');
      this.sendBotiIntro();
      this.next();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../scss/mixins';

  .whatsapp-optin {
    @include white-page-frame;
    height: 100%;

    .optin-content {
      @include responsive-padding;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .intro {
        margin-top: 30px;
        text-align: center;
        font-size: 18px;
        line-height: 24px;

        .whatsapp-icon {
          vertical-align: middle;
          margin-bottom: 4px;
        }

        .lower-intro {
          margin-top: 10px;
          font-weight: bold;
        }
      }

      .optin-img {
        width: 300px;
        margin-top: 10px;
      }

      .button-wrapper {
        @include responsive-padding;
        @include responsive-padding-top-bottom;
        .riseup-button {
          width: 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/non-authenticated/wine-and-dine/signup/steps/WhatsappOptIn.vue